import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../../components/common/SectionHeading';

const Wrapper = styled.section`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: ${({ theme }) => theme.shadows.md};

  @media (max-width: 768px) {
    padding: 1.75rem;
  }
`;

const Banner = styled.div`
  width: 100%;
  height: 300px;
  border-radius: 1.5rem;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(246, 173, 85, 0.2));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '💼';
    font-size: 8rem;
    opacity: 0.3;
    position: absolute;
  }

  @media (max-width: 768px) {
    height: 200px;
    margin-bottom: 2rem;

    &::before {
      font-size: 5rem;
    }
  }
`;

const Subtitle = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.6;
  margin: 1.5rem 0 2.5rem;
`;

const DetailSection = styled.div`
  margin-top: 3rem;
  padding-top: 2.5rem;
  border-top: 2px solid ${({ theme }) => theme.colors.surfaceMuted};
`;

const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const DetailCard = styled.div`
  padding: 2rem;
  background: ${({ theme }) => theme.colors.surfaceMuted};
  border-radius: 1.25rem;
  border: 2px solid ${({ theme }) => theme.colors.primary}15;
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary}30;
    box-shadow: ${({ theme }) => theme.shadows.md};
    transform: translateY(-2px);
  }
`;

const DetailTitle = styled.h4`
  margin: 0 0 1rem;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.primary};
`;

const DetailContent = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: 1.8;

  ul {
    margin: 0.75rem 0;
    padding-left: 1.5rem;
    
    li {
      margin: 0.5rem 0;
    }
  }
`;

const programDetails = [
  {
    title: '교육 목표',
    content: (
      <ul>
        <li>직무 역량 강화를 위한 실무 코딩 교육</li>
        <li>전직 및 이직을 위한 프로그래밍 스킬 습득</li>
        <li>프로젝트 기반 실전 경험 축적</li>
        <li>업무 효율성 향상을 위한 자동화 스크립트 작성</li>
      </ul>
    ),
  },
  {
    title: '교육 과정',
    content: (
      <ul>
        <li>파이썬 실무 활용 및 데이터 분석</li>
        <li>웹 개발 풀스택 과정 (Frontend + Backend)</li>
        <li>실전 프로젝트 개발 및 배포</li>
        <li>업무 자동화 및 효율화 도구 개발</li>
      </ul>
    ),
  },
  {
    title: '교육 특징',
    content: (
      <ul>
        <li>직장인을 위한 유연한 수업 시간 운영</li>
        <li>실무 중심의 프로젝트 기반 학습</li>
        <li>포트폴리오 제작 및 취업 지원</li>
        <li>온라인/오프라인 병행 수업 가능</li>
      </ul>
    ),
  },
];

const AdultProgramPage = () => (
  <Wrapper>
    <Banner />
    <SectionHeading
      eyebrow="성인 프로그램"
      title="성인 코딩 교육 프로그램"
    />
    <Subtitle>
      직장인과 성인을 위한 실무 중심의 코딩 교육 프로그램입니다.<br />
      업무 효율성 향상부터 전직 준비까지, 실전에 바로 활용할 수 있는 프로그래밍 스킬을 배울 수 있습니다.
    </Subtitle>
    <DetailSection>
      <DetailGrid>
        {programDetails.map((detail) => (
          <DetailCard key={detail.title}>
            <DetailTitle>{detail.title}</DetailTitle>
            <DetailContent>{detail.content}</DetailContent>
          </DetailCard>
        ))}
      </DetailGrid>
    </DetailSection>
  </Wrapper>
);

export default AdultProgramPage;


